export default __webpack_public_path__ + "static/media/message_light_blue.3850b942.svg";